import { useUserStore } from '~/composables/useUserStore';

export default defineNuxtRouteMiddleware(async (to, from) => {
    // Only use Nuxt composables on the client side
    if (process.client) {
        const { user, fetchUser, token, setShowLayout } = useUserStore();

        if (!token.value) {
            // Handle redirection for reads/[id] -> reads/preview/[id]
            if (to.path.startsWith('/reads/') && !to.path.startsWith('/reads/preview/')) {
                console.log('to.path', to.path)
                const readId = to.params.id;
                return navigateTo(`/reads/preview/${readId}`);
            }
            if ((to.path.startsWith('/field/feed') || to.path.startsWith('/feed')) && !to.path.startsWith('/field/review')) {
                console.log('to.path', to.path)
                return navigateTo(`/field/review`);
            }
            if (to.path.startsWith('/field/users/') && !to.path.startsWith('/field/users/preview/')) {
                console.log('to.path', to.path)
                const userId = to.params.id;
                return navigateTo(`/field/users/preview/${userId}`);
            }
            return navigateTo('/login');
        }

        if (!user.value) {
            await fetchUser();
        }

        const role = user.value?.role;

        if (role && user.value) {
            // Admin can access all paths, no redirection needed
            if (to.path.startsWith('/field/users/')) {
                const userId = to.params.id;
                if (userId === user.value._id && user.value.role === 'artist') {
                    return navigateTo('/talent/profile');
                }
                console.log('users', user.value);
                if (user.value.admin) {
                    //return navigateTo(`/dashboard/talent/profile/${to.path.split('/')[to.path.split('/').length - 1]}`);
                    return;
                }
            }
            if (role === 'admin' || user.value.admin) {
                if (to.path === '/field/feed' && from.path === '/login') {
                    return navigateTo('/dashboard');
                }

                setShowLayout(true);
                return;
            }
            setShowLayout(true);
        }
    }
    // For server-side rendering, allow the request to proceed without authentication
    // The page will handle authentication check on client side after hydration
});